/**
 * This file stores functions related to parse objects.
 */

/** Checks weather attr exists in large Obj
 *
 * Use example:
 *
 * let a = {
 *    b:{
 *
 *      c: "I exist"
 *
 *    }
 *
 * }
 *
 *
 * let c = resolve(a)('b')('c')()
 *
 * console.log(c)   // "I exist"
 *
 * let c = resolve(a)('b')('d')('e')('f')....('z')()
 *
 * console.log(c)  // undefined   AND there is no error trying to reach attr d
 *
 * @param value
 * @returns {Function}
 */
export function resolve(value) {
  return function(key) {
    return key ? resolve((value || {})[key]) : value;
  };
}

/**
 * Checks if obj is empty
 *
 * isEmpty({}) : true
 *
 * @param obj
 * @returns {boolean}
 */

export function isEmpty(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }

  return true;
}

/**
 * Returns true if elements of array are equal
 * @param arr1
 * @param arr2
 * @returns {boolean}
 */
export function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;
  for (var i = arr1.length; i--; ) {
    if (arr1[i] !== arr2[i]) return false;
  }

  return true;
}

/**
 *
 * Takes an object and changes a particular attr with the key in dot notation.
 * Example:
 *
 * let a = {
 *
 *    b: {
 *
 *       c: {
 *
 *          d: 1
 *
 *       }
 *
 *    }
 *
 * }
 *
 * setData("b.c.d", 2, a)
 * console.log(a)   // a={b:{c:{d:2}}}
 *
 *
 * @param key
 * @param val
 * @param obj
 */

export function setData(key, val, obj) {
  if (!obj) obj = data; //outside (non-recursive) call, use "data" as our base object
  var ka = key.split(/\./); //split the key by the dots
  if (ka.length < 2) {
    obj[ka[0]] = val; //only one part (no dots) in key, just set value
  } else {
    if (!obj[ka[0]]) obj[ka[0]] = {}; //create our "new" base obj if it doesn't exist
    obj = obj[ka.shift()]; //remove the new "base" obj from string array, and hold actual object for recursive call
    setData(ka.join('.'), val, obj); //join the remaining parts back up with dots, and recursively set data on our new "base" obj
  }
}

export function unifyArray(array) {
  var a = array.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (JSON.stringify(a[i]) == JSON.stringify(a[j])) a.splice(j--, 1);
    }
  }

  return a;
}

/**
 * Merges array of objects by a key ('by') specified.   ( n -> 1) Left join?
 * @param source
 * @param merge
 * @param by
 */
export const mergeArray = (source, merge, by) =>
  source.map(item => ({
    ...item,
    ...(merge.find(i => i[by] === item[by]) || {})
  }));



// WEBPACK FOOTER //
// ./lib/parser.js